import { render } from "./Developer.vue?vue&type=template&id=1e784f9b&scoped=true"
import script from "./Developer.vue?vue&type=script&lang=js"
export * from "./Developer.vue?vue&type=script&lang=js"

import "./Developer.vue?vue&type=style&index=0&id=1e784f9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e784f9b"]])

export default __exports__